import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Accordion, Card, Dropdown } from 'react-bootstrap';
import { toast } from 'react-toastify';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import CloseIcon from '@material-ui/icons/Close';
import Radio from '@material-ui/core/Radio';
import { useHistory } from 'react-router-dom';
import moment from "moment";
import { analytics, logEvent }  from "~/services/firebaseConfig";

import {
  PageContainer,
  ContainerItems,
  Title,
  StatusOrder,
  ContentStatus,
  ItemDetails,
  StatusCollor,
  Status,
  ButtonEdit,
  LoadingIcon,
  BackIcon
} from "./styles";
import {
  CardHeader,
  SelectProduct,
  IconProductStyles,
  ContainerButton,
  AlignDropdownBranch,
  AlignProducts,
  TextQuantity,
  InputQuantity,
  DivisionQuantityButtons
} from "~/pages/Order/styles";

import api from "~/services/api";
import HeaderMobile from "~/components/layout/HeaderOld";
import p13Cinza from "~/assets/images/botijao-p13-cinza.svg";
import IconProduct from "~/components/layout/IconProduct";
import { InfoButton, OutlineGrayButton } from "~/components/layout/Buttons";
import Items from "~/components/pages/Order/Items";
import OrderTypeEdit from "~/components/pages/OrderEdit/OrderTypeEdit";
import Loading from '~/components/layout/Loading';
import OpenChatBot from '~/components/layout/Chatbot';

import back from '~/assets/images/arrow.svg';
import { hasNumberInString, replaceNumberInString } from '~/utils/utils';

export default function OrderEdit({ activeModal, showModal }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const products = useSelector(state => state.orderReducer.products);
  const selectedBranch = useSelector(
    state => state.orderReducer.selectedBranch,
  );

  const orderEditReducer = useSelector(state => state.orderEditReducer);

  const [loadingPage, setLoadingPage] = useState(true);
  const [loadingOrder, setLoadingOrder] = useState(false);
  const [expand, setExpand] = useState(false);
  const [openItems, setOpenItems] = useState(false);
  const [branches, setBranches] = useState([]);
  const [zero, setZero] = useState(false);
  const [productIndex, setProductIndex] = useState(0);
  const [product, setProduct] = useState('');
  const [quantity, setQuantity] = useState(0);
  const [shippingMode, setShippingMode] = useState('');
  const [disableButton, setDisableButton] = useState(true);
  const [messageErrorProduct, setMessageErrorProduct] = useState(false);

  const addItem = item => {
    setQuantity(0);
    setProduct(products[0]);
    let orderAdded = orderEditReducer.orders
    orderAdded.push({
      quantity: item.quantity,
      code: item.product.code,
      name: item.product.name
    })
    dispatch({ type: 'SET_ORDERS_EDIT', orders: orderAdded });
  };

  const addProducts = products => {
    dispatch({ type: 'ADD_PRODUCT', products });
  };

  const StatusText = ({ status }) => {
    if (
      status === "AGUARDANDO ANÁLISE DO FINANCEIRO" ||
      status === "EM ANÁLISE PELO FINANCEIRO"
    ) {
      return <span>PEDIDO RECEBIDO AGUARDANDO ANÁLISE</span>;
    } else if(status === 'AGUARDANDO APROVAÇÃO DA LOGÍSTICA PARA INCLUSÃO NA PROGRAMAÇÃO' ||
      status === 'AGUARDANDO APROVAÇÃO DO CONSULTOR COMERCIAL PARA INCLUSÃO NA PROGRAMAÇÃO') {
      return <span>AGUARDANDO ANÁLISE PARA INCLUSÃO NA PROGRAMAÇÃO</span>
    } else if (status === "LIBERADO") {
      return <span>PEDIDO LIBERADO PELO FINANCEIRO</span>;
    } else if (status === "NÃO LIBERADO PELO FINANCEIRO") {
      return <span>PEDIDO COM RESTRIÇÃO</span>;
    } else {
      return <span>PEDIDO CANCELADO</span>;
    }
  };

  const CustomSelect = React.forwardRef(({ children, onClick }, ref) => {
    return (
      <SelectProduct
        ref={ref}
        onClick={event => {
          event.preventDefault();
          onClick(event);
          expand ? setExpand(false) : setExpand(true);
        }}
      >
        <IconProduct productName={children} />
        <span>{children}</span>
        {expand ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </SelectProduct>
    );
  });

  const getProducts = async () => {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };
    const url = `/residential/store/v1/stores/${localStorage.getItem(
      'storeId',
    )}/business-characteristics`;

    await api
      .get(url, parameters)
      .then(res => {
        setBranches(res.data.supplyBranches);
        dispatch({ type: "ADD_SUPPLYBRANCH", supplyBranches: res.data.supplyBranches });
        if(!localStorage.getItem("supplyBranchId")) {
          localStorage.setItem(
            'supplyBranchId',
            res.data.standardSupplyBranchId,
          );
        }
        localStorage.setItem(
          'standardServiceType',
          res.data.standardServiceType,
        );
        let indexSupplyBranch = null
        if(product === "") {
          res.data.supplyBranches.map((element, index) => {
            if(element.id === orderEditReducer.orderChoosed.supplyBrancheId) {
              dispatch({ type: "SELECT_BRANCH", selectedBranch: index })
              indexSupplyBranch = index
            }
            return ''
          })
        }
        orderEditReducer.orderChoosed.products.map((product, index) => {
          res.data.supplyBranches[indexSupplyBranch ? indexSupplyBranch : 0].products.map((element) => {
            if(element.code === product.code) {
              product["name"] = element.name
            }
            return ''
          })
          return ''
        })
        setShippingMode(res.data.standardShippingMode);
        if(shippingMode === "") {
          addProducts(
            res.data.supplyBranches[indexSupplyBranch ? indexSupplyBranch : 0]
              .products
          );
        }
        setProduct(
          res.data.supplyBranches[indexSupplyBranch ? indexSupplyBranch : 0]
            .products[0]
        );
        dispatch({
          type: "ADD_DATE_EDIT",
          date: moment(orderEditReducer.orderChoosed.deliveryDate, "YYYY-MM-DD").format("DD/MM/YYYY")
        });
        if(disableButton) {
          dispatch({ type: "SET_ORDERS_EDIT", orders: orderEditReducer.orderChoosed.products });
        }
        setLoadingPage(false);
      })
      .catch(err => {
        const erro = err.response;
        if(erro.status === 502) {
          toast.error(
            'Ocorreu um erro no servidor',
          );
          if (window.screen.width < 770) {
            history.push('/status');
          } else {
            activeModal(false);
          }
          setLoadingPage(false);
        }
        if (erro.status === 404) {
          toast.error('Pedido de Abastecimento não disponível na sua região');
          setTimeout(() => {
            if (window.screen.width < 770) {
              history.push('/status');
            } else {
              activeModal(false);
            }
            setLoadingPage(false);
          }, 3500);
        }
      });
  };

  useEffect(() => {
    if (window.screen.width > 770) {
      if(orderEditReducer.requisitionEdit) {
        getProducts();
      }
    } else {
      getProducts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderEditReducer.branchChanged, orderEditReducer.requisitionEdit]);

  useEffect(() => {
    if(orderEditReducer.editMobile) {
      setDisableButton(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderEditReducer.editMobile]);

  function errorVerification(err) {
    setLoadingOrder(false);
    let displayToast = false;

    const errorsForDisplayApi = [
      "Não foi possível efetuar o cancelamento do pedido. Favor entrar em contato com a logística da filial",
      "A data informada ultrapassa o prazo para gerar pedido com antecedência. Prazo: {number} dias",
      "A filial abastecedora não trabalha neste dia da semana",
      "A data informada é um feriado, favor informar um dia útil.",
      "O horário de atendimento da revenda para pedidos nesta data foi excedido.",
      "O horário de atendimento da revenda para pedidos nesta data foi excedido."
    ]
    const errosDefined = {
      "A filial abastecedora não possui um calendário de trabalho cadastrado": "Não é possível criar solicitação de abastecimento. Favor acionar o suporte para efetuar os devidos ajustes em seu cadastro com a Ultragaz.",
      "A quantidade solicitada no pedido excede o volume permitido.Volume total solicitado: {number} kg. Volume total permitido: {number} kg.": "Quantidade acima do permitido"
    }
    const errorDefault = "Não é possível criar solicitação de abastecimento. Favor acionar o suporte para efetuar os devidos ajustes em seu cadastro com a Ultragaz.";

    const message = hasNumberInString(err.response.data.message) ? replaceNumberInString(err.response.data.message, "{number}") : err.response.data.message;
    if (err.response.status !== 502) {
      for (const error of errorsForDisplayApi){
        if (message.includes(error)) {
          if (message === error) {
            displayToast = true;
            toast.error(err.response.data.message);
          } else {
            if (!displayToast){
              const messagesSplitedDisplay = err.response.data.message.split(';')
              if (messagesSplitedDisplay.length <= 2) {
                displayToast = true;
                toast.error(messagesSplitedDisplay[0]);
              } else {
                displayToast = true;
                toast.error(messagesSplitedDisplay[0]);
                toast.error(messagesSplitedDisplay[messagesSplitedDisplay.length -1]);
              }
            }
          }
        }
      }
      for (const key in errosDefined) {
        if (message.includes(key)) {
          if (message === key) {
            displayToast = true;
            toast.error(errosDefined[key]);
          } else {
            const messagesSplitedDefined = message.split(';')
            if (messagesSplitedDefined.length <= 2) {
              if (messagesSplitedDefined[0] === key) {
                displayToast = true;
                toast.error(errosDefined[key]);
              }
            } else {
              if (messagesSplitedDefined[0] === key) {
                displayToast = true;
                toast.error(errosDefined[key]);
              }
              if (messagesSplitedDefined[messagesSplitedDefined.length -1] === key) {
                displayToast = true;
                toast.error(errosDefined[key]);
              }
            }
          }
        }
      }
      if (!displayToast) {
        toast.error(errorDefault);
      }
    } else {
      toast.error('Ocorreu um erro, tente novamente!');
    }
  }

  function editOrder() {
    setLoadingOrder(true);
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'PATCH',
      headers: header,
    };
    const url = `/residential/order/v1/orders-ga/${orderEditReducer.orderChoosed.id}`;

    const body = {
      deliveryDate: moment(orderEditReducer.date, "DD/MM/YYYY").format("YYYY-MM-DD"),
      products: orderEditReducer.orders,
      supplyBrancheId: branches[selectedBranch ? selectedBranch : 0].id,
      orderType: "GAS_ENVASADO"
    }
    api
      .patch(url, body, parameters)
      .then((res) => {
        toast.success("Pedido editado com sucesso");
        if(window.screen.width > 768) {
          activeModal(false);
        } else {
          history.push("/status");
        }
        dispatch({ type: "ORDER_EDITED_DONE" });
        setLoadingOrder(false);
      })
      .catch((err) => {
        setLoadingOrder(false);
        if(err.response.status === 422) {
          errorVerification(err)
        } else {
          toast.error("Ocorreu algum erro, tente novamente");
        }
      })
  }

  return(
    <PageContainer>
      <HeaderMobile />
      <BackIcon
        onClick={() => {
          if (window.screen.width > 768) {
            activeModal(false);
          } else {
            history.push('/status');
            dispatch({ type: 'ORDER_EDIT_DONE' });
          }
        }}
      >
        <img src={back} alt="Ícone para voltar" />
      </BackIcon>
      <Title>
        <img src={p13Cinza} alt="Ícone butijão" />
        <span>Editar Pedido de Abastecimento</span>
      </Title>
      {
        loadingPage ? <Loading width="10%" margin="30% auto" /> : (
        <>
          <StatusOrder>
            <h4>Pedido {orderEditReducer.orderChoosed.number}</h4>
            <ItemDetails>
              <Status>Status: </Status>
              <ContentStatus>
                <StatusCollor status={orderEditReducer.orderChoosed.status} />
                <StatusText status={orderEditReducer.orderChoosed.status} />
              </ContentStatus>
            </ItemDetails>
          </StatusOrder>
          <ContainerItems>
            <Items setDisableButton={setDisableButton} editedOrder={true} />
            {(openItems || orderEditReducer.orders.length === 0) && (!messageErrorProduct) ? (
              <>
                <Accordion defaultActiveKey="0">
                <Card.Header style={CardHeader}>
                    Item - {orderEditReducer.orders.length + 1}
                    <CloseIcon onClick={() => setOpenItems(false)} />
                  </Card.Header>
                  <Card>
                    <Card.Body>
                      <Dropdown className="products">
                        <Dropdown.Toggle
                          as={CustomSelect}
                          id="dropdown-custom-components"
                        >
                          {
                            products ? products[productIndex].name : null
                          }
                        </Dropdown.Toggle>

                        <Dropdown.Menu style={{ width: '100%' }}>
                          { products ? products.map((element, index) => {
                            return (
                              <Dropdown.Item
                                key={element.code}
                                eventKey={`${element.code}`}
                                onClick={() => {
                                  setProductIndex(index);
                                  setProduct(element);
                                }}
                                style={AlignDropdownBranch}
                              >
                                <AlignProducts>
                                  <Radio
                                    color="primary"
                                    checked={
                                      products ? products[productIndex].name ===
                                      element.name : null
                                    }
                                  />
                                  <span className="product">
                                    {element.name}
                                  </span>{' '}
                                  <span className="align-icon">
                                    <IconProduct
                                      productName={element.name}
                                      styles={{
                                        p2: IconProductStyles,
                                        p5: IconProductStyles,
                                        p20: IconProductStyles,
                                        p45: IconProductStyles,
                                        p90: IconProductStyles,
                                        p13: IconProductStyles,
                                      }}
                                    />
                                  </span>
                                </AlignProducts>
                              </Dropdown.Item>
                            );
                          }) : null}
                        </Dropdown.Menu>
                      </Dropdown>
                      <TextQuantity>Escolha a quantidade</TextQuantity>
                      <InputQuantity
                        type="number"
                        value={quantity === null || quantity < 0 ? 0 : quantity}
                        onFocus={() => {
                          if (quantity === 0) {
                            setQuantity(null);
                          }
                          logEvent(analytics, 'abastecimento_campo_digitacao');
                        }}
                        onChange={event => {
                          if (event.target.value === '') {
                            setZero(true);
                          }
                          const newValue = parseInt(event.target.value);
                          if (typeof newValue === 'number') {
                            setQuantity(newValue);
                          }
                        }}
                      />
                      <DivisionQuantityButtons>
                        {[1, 10, 100].map(button => (
                          <OutlineGrayButton
                            className={`quantity-${button}`}
                            margin={'1rem .5rem 1rem 0'}
                            onClick={() => {
                              logEvent(analytics, 'abastecimento_botoes_atalho');
                              (zero && isNaN(quantity)) || (quantity < 0)
                                ? setQuantity(button)
                                : setQuantity(quantity + button);
                            }}
                          >
                            +{button === 1 ? '01' : button}
                          </OutlineGrayButton>
                        ))}
                      </DivisionQuantityButtons>
                      <InfoButton
                        style={{ marginTop: '.8rem' }}
                        onClick={() => {
                          let possible = true;
                          if (quantity > 0) {
                            if (orderEditReducer.orders.length > 0) {
                              orderEditReducer.orders.map(item => {
                                if (
                                  item.name ===
                                  branches[
                                    selectedBranch ? selectedBranch : 0
                                  ].products[productIndex].name
                                ) {
                                  toast.error(
                                    'Não é possível inserir produtos duplicados',
                                  );
                                  possible = false;
                                }
                                return ''
                              });
                            }
                            if (possible && product !== '') {
                              let sendProduct =
                                branches[
                                  selectedBranch ? selectedBranch : 0
                                ].products[productIndex];
                              addItem({
                                id: orderEditReducer.orders.length + 1,
                                product: sendProduct,
                                quantity,
                              });
                              setDisableButton(false);
                              setOpenItems(false);
                            }
                          }
                        }}
                      >
                        Confirmar
                      </InfoButton>
                    </Card.Body>
                  </Card>
                </Accordion>
              </>
            ) : (
              <ContainerButton>
                <OutlineGrayButton disableButton={messageErrorProduct}
                  onClick={() => {
                    if(!messageErrorProduct) {
                      setOpenItems(true);
                    }
                  }}
                >
                  + Adicionar Mais Itens
                </OutlineGrayButton>
              </ContainerButton>
            )}
            <OrderTypeEdit
              filiais={branches}
              isFrotaPropria={true}
              shippingMode={shippingMode}
              setDisableButton={setDisableButton}
              setMessageErrorProduct={setMessageErrorProduct}
              openItems={openItems}
              setOpenItems={setOpenItems}
            />
            <ButtonEdit>
              <button
                disable={disableButton || orderEditReducer.orders.length < 1}
                onClick={() => {
                  if(!disableButton && orderEditReducer.orders.length > 0) {
                    editOrder()
                  }
                }}
              >
                {
                  loadingOrder ? (
                    <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                  ) : (
                    <>Editar pedido</>
                  )
                }
              </button>
            </ButtonEdit>
        </ContainerItems>
        </>
      )}
      <OpenChatBot />
    </PageContainer>
  );
}
